import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import {
  Box,
  Button,
  Container,
  DialogContentText,
  Grid,
  Stack,
} from "@mui/material";
import { ButtonOwnProps, Dialog } from "@mui/material";

import conf from "config-dlm";
import SectionHeader from "components/utils/SectionHeader";

type ConfirmationViewProps = {
  open: boolean;
  type: string;
  message: string | JSX.Element;
  onClose: () => void;
  onConfirm: () => void;
};
const ConfirmationView = (props: ConfirmationViewProps) => {
  const { open, type, message, onClose, onConfirm } = props;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={onClose}>
      <Container component="main" sx={conf.STYLE.DIALOG}>
        <SectionHeader
          key={`${type}-confirmation-button`}
          icon={<WarningIcon />}
          title={`Confirm: ${type.toUpperCase()}`}
          buttons={[
            <Button
              key={"confirmation-button-close"}
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon />
            </Button>,
          ]}
        />

        <Box component="form" noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container p={1} mt={1} border={1} borderRadius={1}>
                <DialogContentText>{message}</DialogContentText>
              </Grid>
            </Grid>
          </Grid>

          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ mt: 2, mb: 2 }}
          >
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>

            <Button variant="contained" onClick={handleConfirm}>
              Confirm
            </Button>
          </Stack>
        </Box>
      </Container>
    </Dialog>
  );
};

type ButtonWithConfirmProps = {
  type: string;
  label: string;
  size?: ButtonOwnProps["size"];
  color?: ButtonOwnProps["color"];
  message: string | JSX.Element;
  variant?: ButtonOwnProps["variant"];
  disabled?: boolean;
  onConfirm: () => void;
  showButton?: boolean;
  defaultOpen?: boolean;
};

const ButtonWithConfirm = (props: ButtonWithConfirmProps) => {
  const {
    size = "medium",
    color = "secondary",
    variant = "contained",
    disabled = false,
    type,
    label,
    message,
    onConfirm,
    showButton = true,
    defaultOpen = false,
  } = props;

  const [open, setOpen] = useState(defaultOpen);

  const onClick = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <div>
      {showButton && (
        <Button
          size={size}
          color={color}
          variant={variant}
          disabled={disabled}
          onClick={onClick}
        >
          {label}
        </Button>
      )}

      <ConfirmationView
        open={open}
        type={type}
        message={message}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    </div>
  );
};

export default ButtonWithConfirm;
